import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutUrl, ctaHref } from '../data/content';
import { trackInitiateCheckout } from '../utils/metaPixel';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  size?: 'md' | 'lg';
  block?: boolean;
  className?: string;
  /** Botón de compra: dispara InitiateCheckout y continúa al checkout. */
  checkout?: boolean;
};
export function CtaButton({
  children,
  href = ctaHref,
  size = 'lg',
  block = false,
  className = '',
  checkout = false
}: CtaButtonProps) {
  const sizes = {
    md: 'px-5 py-2.5 text-sm',
    lg: 'px-7 py-4 text-[15px] sm:px-9 sm:py-5 sm:text-base'
  };
  const isCheckout = checkout && checkoutUrl !== '';
  const finalHref = isCheckout ? checkoutUrl : href;
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!isCheckout) return;
    // Respetar abrir en pestaña nueva (Ctrl/Cmd/clic central): solo registrar el evento.
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) {
      window.fbq?.('track', 'InitiateCheckout', {
        content_name: 'Megapack Maestro de Sesiones',
        content_type: 'product'
      });
      return;
    }
    e.preventDefault();
    trackInitiateCheckout(finalHref);
  };
  return <a href={finalHref} onClick={handleClick} className={`group inline-flex items-center justify-center gap-2.5 rounded-full bg-terra font-semibold uppercase tracking-[0.04em] text-paper shadow-[0_10px_24px_-12px_rgba(176,85,47,0.7)] transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-terra-deep active:translate-y-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-terra ${sizes[size]} ${block ? 'w-full' : ''} ${className}`} data-id="element-49" data-mp="3ew9i2piafhk5">
      <span className="whitespace-nowrap" style={{
      fontSize: "12px"
    }} data-id="element-50" data-mp="bhdqd63h1ydk">{children}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-51" data-mp="gg88s6xj1kx5" />
    </a>;
}